import { render, staticRenderFns } from "./addPromotionalImage.vue?vue&type=template&id=0a4164e9&scoped=true&"
import script from "./addPromotionalImage.vue?vue&type=script&lang=ts&"
export * from "./addPromotionalImage.vue?vue&type=script&lang=ts&"
import style0 from "./addPromotionalImage.vue?vue&type=style&index=0&id=0a4164e9&lang=scss&scoped=true&"
import style1 from "./addPromotionalImage.vue?vue&type=style&index=1&id=0a4164e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4164e9",
  null
  
)

export default component.exports